import styled from 'styled-components';
import Label from '../../../../_shared/components/Label';

export const StyledLabel = styled(Label)`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  padding-right: 18px;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const StyledTip = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  font-size: ${({ theme }) => theme.FONT_SIZES.XSMALL};
  line-height: 17px;
  margin-right: 10px;
`;
